export default {
    cancelText: 'Отмена',
};
